var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import AsyncSelect from '@/components/async-select/AsyncSelect';
import LoaderCard from '@/components/loader-card/LoaderCard';
import SelectFilter from '@/components/select-filter/SelectFilter';
import { Subject } from '@/models/Subject';
import ErrorHandler from '@/support/ErrorHandler';
import { Component, Vue, Watch } from 'vue-property-decorator';
let CreateDialog = class CreateDialog extends Vue {
    constructor() {
        super(...arguments);
        this.currentStep = 1;
        this.choice = '';
        this.selectedFile = null;
        this.isUploading = false;
        this.uploadResults = {
            success: [],
            updated: [],
            failed: {},
        };
        this.selectedArea = null;
        this.selectedTopic = null;
        this.topics = [];
    }
    mounted() {
        //
    }
    close() {
        this.clear();
        this.$emit('input', false);
    }
    clear() {
        this.currentStep = 1;
        this.choice = '';
        this.selectedFile = null;
        this.selectedArea = null;
        this.selectedTopic = null;
        this.topics = [];
    }
    uploadDisabled() {
        if (!this.selectedFile) {
            return true;
        }
        if (this.choice === 'area') {
            return false;
        }
        if (this.choice === 'topic' && this.selectedArea) {
            return false;
        }
        if (this.choice === 'subject' && this.selectedArea && this.selectedTopic) {
            return false;
        }
        return true;
    }
    onFileChange(event) {
        if (!event.target.files.length) {
            return;
        }
        this.selectedFile = event.target.files[0];
        if (!this.selectedFile) {
            return;
        }
    }
    currentStepChanged(currentStep, previousStep) {
        if (currentStep === 3) {
            this.createFromExcel();
        }
    }
    createPayload() {
        const payload = {};
        if (this.choice === 'area') {
            payload.curriculum = this.currentCurriculum.id;
        }
        else if (this.choice === 'topic') {
            payload.subject = this.selectedArea;
        }
        else {
            payload.subject = this.selectedTopic;
        }
        payload.excel = this.selectedFile;
        return payload;
    }
    // public create() {
    //   this.isUploading = true;
    //   new Subject()
    //   .create(this.createPayload())
    //   .then((response: any) => {
    //   });
    //   // this.choice === 'import' ? this.createFromExcel() : this.createUser();
    // }
    createFromExcel() {
        this.isUploading = true;
        new Subject()
            .create(this.createPayload())
            .then((response) => {
            this.isUploading = false;
            this.$emit('subjectsAdded');
        })
            .catch((error) => {
            ErrorHandler.network(error);
            this.currentStep = 1;
            this.isUploading = false;
        });
    }
    getAreaChildren(id) {
        if (!this.currentCurriculum || !this.currentCurriculum.subjects) {
            return;
        }
        const area = this.currentCurriculum.subjects.find((area) => {
            return area.id === id;
        });
        if (area) {
            this.topics = area.children || [];
        }
    }
    get currentCurriculum() {
        return this.$store.state.curriculum;
    }
    areaSelected(id) {
        this.getAreaChildren(id);
    }
    get getFailedCount() {
        return Object.keys(this.uploadResults.failed).length;
    }
    get headerMessage() {
        if (this.choice) {
            return this.$tc(`curriculum.import.${this.choice}.header`).toString();
        }
        return '';
    }
    get successMessage() {
        if (this.choice) {
            return this.$tc(`curriculum.import.${this.choice}.success`).toString();
        }
        return '';
    }
};
__decorate([
    Watch('currentStep'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number, Number]),
    __metadata("design:returntype", void 0)
], CreateDialog.prototype, "currentStepChanged", null);
__decorate([
    Watch('selectedArea'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], CreateDialog.prototype, "areaSelected", null);
CreateDialog = __decorate([
    Component({
        components: {
            AsyncSelect,
            SelectFilter,
            LoaderCard,
        },
    })
], CreateDialog);
export default CreateDialog;
